import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Usuario, Csr, CsrDetalhe, Organizacao, StatusFatoresAltenticacao } from '../shared/index';
import { ActivatedRoute, Router } from '@angular/router';
import { CertificadoService } from '../shared/service/certificado/certificado.service';
import { LoginService } from '../shared/service/login/login.service';
import { Location } from '@angular/common';
import { UtilService } from '../shared/service/util/util.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { UsuarioService } from '../shared/service/usuario/usuario.service';
import { CsrDetalhePj } from '../shared/model/csrDetalhePj';
@Component({
  selector: 'app-solicitacao-certificado',
  templateUrl: './solicitacao-certificado.component.html',
  styleUrls: ['./solicitacao-certificado.component.css']
})

export class SolicitacaoCertificadoComponent implements OnInit {

  public statusFatoresAltenticacao: StatusFatoresAltenticacao;
  public usuario: Usuario;
  public organizacao: Organizacao;
  public confirm: string;
  public otpCadastrado: boolean;
  public disabledSolicitarSubmit: boolean = false;
  public juridico: boolean = false;

  public emailRegex: string = "[a-z0-9_\\-]+(\\.[_a-z0-9\\-]+)*@([_a-z0-9\\-]+\\.)+([a-z]{2}|aero|arpa|biz|com|coop|edu|gov|info|int|jobs|mil|museum|name|nato|net|org|pro|travel)";

  public maskCpf = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  public maskCnpj = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  public maskCei = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/];
  public maskData = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public maskUF = [/[a-zA-Z]/, /[a-zA-Z]/];
  public maskTel = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  @ViewChild('cadastroCpfDialog', { static: true }) cadastroCpfDialog: TemplateRef<any>;
    private cadastroCpfDialogRef: MatDialogRef<TemplateRef<any>>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private certificadoService: CertificadoService,
    private utilService: UtilService,
    private loginService: LoginService,
    private location: Location,
    private dialog: MatDialog,
    private usuarioService : UsuarioService,
  ) {
  }

  ngOnInit() {
    this.usuario = this.route.snapshot.data['obterDadosUsuario'];
    this.usuario.csr = new Csr();
    this.usuario.csr.csrDetalhe = new CsrDetalhe();
    this.usuario.csr.csrDetalhe.profissao = null;
    this.usuario.csr.csrDetalhePj = new CsrDetalhePj();
    this.usuario.organizacaoId = JSON.parse(localStorage.getItem("currentUser")).organizacaoId;
    this.verificaOtp();
    this.verificaCpf();
    this.usuario.csr.csrDetalhe.cpf = this.usuario.cpf;
  }

  verificaOtp() {
    this.certificadoService.getStatusFatores(this.usuario.id, this.usuario.organizacaoId).subscribe(
      res => {
        this.otpCadastrado = res.tokenOtpObrigatorio && res.validaTokenNaSolicitacao;
      },
      err => {
        this.utilService.showError(err.message);
        if (err.status === 401 || err.status === 403) {
          this.loginService.logout();
        }
      }
    );

    return false;
  }

  solicitar() {
    this.disabledSolicitarSubmit = true;
    this.certificadoService.solicitar(this.usuario).subscribe(
      () => {
        this.router.navigate(['/carteira-certificado']);
        this.utilService.showSuccess("Certificado Solicitado com Sucesso");
      },
      err => {
        this.disabledSolicitarSubmit = false;
        this.utilService.showError(err.message);
      }
    );
  }

  lowerCase(email: string) {
    if (email !== undefined)
      this.usuario.csr.csrDetalhe.email = email.toLowerCase();
  }

  cancelar() {
    this.location.back();
  }

  checkCaracterEspecial(event: any){
    var char = String.fromCharCode(event.keyCode);
    var pattern = '[a-zA-Z0-9 ]';

    if (!char.match(pattern)) {
      event.preventDefault();
    }
  }

  verificaCpf(){
    if(this.usuario.cpf === undefined || this.usuario.cpf === null){
      this.cadastroCpfDialogRef = this.dialog.open(this.cadastroCpfDialog, this.utilService.configuracaoDialog());
    }

  }

  cadastraCpf(){
    this.usuarioService.atualizarProprioCadastro(this.usuario, this.usuario.organizacaoId).subscribe(
      _ => {
        this.usuario.csr.csrDetalhe.cpf = this.usuario.cpf;
        this.cadastroCpfDialogRef.close();
        this.utilService.showSuccess("CPF cadastrado com sucesso.");
      },
      err => {
        this.utilService.showError(err.message);
      })
  }
  
    listaProfissoes = [
      'Auxiliar de Enfermagem',
      'Enfermeiro',
      'Enfermeira',
      'Enfermeira Obstetra',
      'Técnica de Enfermagem',
      'Técnico de Enfermagem',
      'Analista de Suporte Sr.',
      'Assistente Social',
      'Condutor',
      'Coordenador de Enfermagem',
      'Escriturário',
      'Fisioterapeuta',
      'Fonoaudióloga',
      'Ginecologista e Obstetra',
      'Médico',
      'Nutricionista',
      'Psicólogo',
      'Psiquiatra',
      'Terapeuta Ocupacional',
      'Outros'
    ];
}
